import type { ProcessedShippingEligibility } from '@/lib/types/shippingEligibilityState';

export type ShippingEligibilityActions =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS'; payload: ProcessedShippingEligibility }
  | { type: 'FETCH_ERROR'; payload: string }
  | { type: 'CLEAR_ERROR' };

export const startFetchEligibility = (dispatch: React.Dispatch<ShippingEligibilityActions>) => {
  dispatch({ type: 'FETCH_START' });
};

export const setEligibilitySuccess = (
  dispatch: React.Dispatch<ShippingEligibilityActions>,
  eligibility: ProcessedShippingEligibility,
) => {
  dispatch({ type: 'FETCH_SUCCESS', payload: eligibility });
};

export const setEligibilityError = (
  dispatch: React.Dispatch<ShippingEligibilityActions>,
  error: string,
) => {
  dispatch({ type: 'FETCH_ERROR', payload: error });
};
